/**
 * Page Loading Component
 * Used as Suspense fallback for lazy-loaded routes
 */

import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

export default function PageLoading() {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        gap: 16,
        height: '100vh',
        width: '100%',
      }}
    >
      <Spin
        indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />}
        size="large"
      />
      <div style={{ color: 'rgba(0, 0, 0, 0.45)' }}>Loading...</div>
    </div>
  );
}
